import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import { withTranslation } from "react-i18next";
import { Paper, Typography, Grid, makeStyles } from "@material-ui/core";

import Counter from "../../Common/Counter";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 40, 
    marginBottom: 40
  },
  title: {
    ...theme.typography.subtitle2,
    marginBottom: 20 
  }
}));

const Quorum = ({ t, onChangeData, committee, disabled }) => {
  const classes = useStyles();
  const [value, setValue] = useState({});

  const handleChange = (prop, name) => {
    setValue({ ...value, [name]: prop });
    onChangeData({ [name]: prop });
  };

  const fillCommittee = (items) => {
    setValue({
      installation: items.countInstalers,
      approval: items.countApprovers,
    });
  };

  useEffect(() => {
    if (!isEmpty(committee)) {
      fillCommittee(committee);
    }
  }, [committee]);

  useEffect(() => {
    onChangeData(value);
  }, [value]);

  return (
    <Paper elevation={1} className={classes.root}>
      <Typography className={classes.title}>
        {t("forms.committee.quorum.title")}
      </Typography>
      <Grid container spacing={3}>
        <Grid item lg={6} xs={12}>
            <Counter              
              valueDefault={value.installation}
              onClickCounter={(installation) =>
                handleChange(installation, "installation")
              }
              text={t("forms.committee.quorum.installation")}
              disabled={disabled}
            />
        </Grid>
        <Grid item lg={6} xs={12}>
          <Counter
            disabled={disabled}
            valueDefault={value.approval}
            onClickCounter={(approval) =>
              handleChange(approval, "approval")
            }
            text={t("forms.committee.quorum.approval")}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default withTranslation()(Quorum);
